import * as DOMPurify from 'dompurify';
const md = require('markdown-it')({
    html: true,
    linkify: true,
    typographer: true
});

export function displayMarkdownInText(text: string): JSX.Element[] {
    return text && text !== '' ? DOMPurify.sanitize(md.render(text)) : text;
}

export function convertNewLineIntoBr(text: string): string {
    return text ? text.replace(/(?:\r\n|\r|\n)/g, '<br/>\n') : text;
}

export function removeNbspFromText(text: string): string {
    if (!text) {
        return text;
    }
    return text.replace(/&nbsp;/g, ' ');
}
